<div class="row">
  <img class='img-fluid w-100' src="assets/img/mainheader.jpg" alt="" />
</div>
